import monacoThemes from "monaco-themes/themes/themelist";

/** Custom color token list  */
const tokenColorList = [
  {
    token: 'keyword', //  keywords
    foreground: '#0077FF', // Blue
  },
  {
    token: 'string', //  strings
    foreground: '#00FF00', // Green
  },
  {
    token: 'number', //  numbers
    foreground: '#FF8800', // Orange
  },
  {
    token: 'comment', //  comments
    foreground: '#AAAAAA', // Light gray
  },
  {
    token: 'variable', //  variables or placeholders
    foreground: '#FF00FF', // Purple
  },
  {
    token: 'predefined', //  predefined 
    foreground: '#D780D6', // Lavender
  },
  {
    token: 'type', //  data types (e.g., INT, VARCHAR)
    foreground: '#FFD700', // Gold
  },
  {
    token: 'function', //  functions
    foreground: '#FF1493', // Deep pink
  },
  {
    token: 'operator', //  operators (e.g., +, -, *, /)
    foreground: '#FFA500', // Orange
  },
  {
    token: 'delimiter', //  punctuation (e.g., commas, semicolons)
    foreground: '#FFFFFF', // White
  }
];

export const themes = Object.entries(monacoThemes).map(
  ([themeId, themeName]) => ({
    label: themeName,
    value: themeId,
    key: themeId,
  })
);

export const defaultCodingTheme = { 
  value: "brilliance-black", 
  label: "Brilliance Black" 
};


export const defaultCodingThemeData = {
  base: 'vs',
  inherit: true,
  rules: [
    { background: '#2D2D2D' },
    ...tokenColorList,
  ],
  colors: {
    "editor.foreground": "#EEEEEE",
    "editor.background": "#0D0D0DFA",
    "editor.selectionBackground": "#0010B499",
    "editor.lineHighlightBackground": "#2D2D2D",
    "editorLineNumber.activeForeground": "#EEEEEE",
    "editorLineNumber.foreground": "#EEEEEE",
    "editor.lineHighlightBorder": "#2D2D2D",
    "editorCursor.foreground": "#EEEEEE",
    "editorWhitespace.foreground": "#CCCCCC1A"
  }
};
